import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { api } from '../../lib/api';
import ArtisanSchedule from './ArtisanSchedule';
import './ArtisanDashboard.css';

function ArtisanDashboard() {
    const { user } = useOutletContext();
    const [displayName, setDisplayName] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Just fetch the name for the welcome message
        const fetchName = async () => {
            try {
                const res = await api.get('/api/artisan/profile');
                if (res.ok) {
                    const data = await res.json();
                    setDisplayName(data.displayName || user.name);
                }
            } catch (e) {
                // Ignore error, fallback to user.name
            } finally {
                setLoading(false);
            }
        };
        fetchName();
    }, [user.name]);

    if (loading) {
        return (
            <div className="section" style={{ textAlign: 'center' }}>
                <p>Loading dashboard...</p>
            </div>
        );
    }

    return (
        <div className="container section animate-fadeIn">
            <div className="artisan-header">
                <div>
                    <h1>Artisan Dashboard</h1>
                    <p style={{ color: 'var(--text-muted)' }}>Welcome back, {displayName || 'Artisan'}</p>
                </div>
                {/* Buttons removed as requested (redundant with sidebar) */}
            </div>

            <ArtisanSchedule />
        </div>
    );
}

export default ArtisanDashboard;
